module.exports = __webpack_public_path__ + "img/FaaS.009084ec.png";